module.exports = __webpack_public_path__ + "static/horizontal-step-1-a0b8ff2e9ac9d3f8f1fc0166329466b7.png";